module.exports = __webpack_public_path__ + "img/mp2.d4095359.png";